
import Vue from "vue";
import SignaturePad, {Options as SignaturePadOptions} from "signature_pad";

interface ISize{
	width:number;
	height:number;
}

export default Vue.extend({
	data(){
		return {
			sig: null as SignaturePad | null,
		};
	},
	props: {
		sigOption: {
			type: Object as ()=>SignaturePadOptions,
			default: ()=>{
				return {
					backgroundColor: "rgba(255,255,255, 0)",
					penColor: "rgb(0, 0, 0)"
				} as SignaturePadOptions;
			},
		},
		w: {
			type: String,
			default: "100%"
		},
		h: {
			type: String,
			default: "100%"
		},
		clearOnResize: {
			type: Boolean,
		},
		disabled: {
			type: Boolean,
		},
		defaultUrl: {
			type: String,
		},
		format: {
			type: String,
			default: ()=>"image/png"
		}
	},
	watch: {
		disabled(val){
			if (!this.sig) return;
			if (val) {
				this.sig.off();
			} else {
				this.sig.on();
			}
		}
	},
	methods: {
		getTargetCanvasSize():ISize{
			let c = this.$refs.canvas as HTMLCanvasElement;
			if (!c) return {width: 0, height: 0};
			let parent = c.parentElement as HTMLDivElement;
			let rect = parent.getBoundingClientRect();
			return {
				width: rect.width,
				height: rect.height
			};
		},
		draw(){
			let canvas = this.$refs.canvas as HTMLCanvasElement;
			if (!canvas) return;
			let size = this.getTargetCanvasSize();
			canvas.width = size.width;
			canvas.height = size.height;
			this.sig = new SignaturePad(canvas as HTMLCanvasElement,this.sigOption);
			window.addEventListener("resize", this.resizeCanvas);
			if (this.disabled) {
				this.sig.off();
			} else {
				this.sig.on();
			}
		},
		resizeCanvas(){
			let c = this.$refs.canvas as HTMLCanvasElement;
			if (!c) return;
			let canvas = c as HTMLCanvasElement;
			let oldWidth = canvas.width;
			let oldHeight = canvas.height;
			let size = this.getTargetCanvasSize();
			canvas.width = size.width;
			canvas.height = size.height;
			let ctx = canvas.getContext("2d");
			if (!ctx) return;
			ctx.scale(size.width/oldWidth, size.height/oldHeight);
			if (this.clearOnResize){
				this.clear();
			}
		},
		clear(){
			if (!this.sig) return;
			this.sig.clear();
		},
		save(){
			let canvas = this.$refs.canvas as HTMLCanvasElement;
			if (!canvas) return;
			canvas.toBlob((blob)=>{
				this.$emit("input", blob);
			}, this.format, 0.95);
		},
		isEmpty(){
			if (!this.sig) return;
			return this.sig.isEmpty();
		},
		undo(){
			if (!this.sig) return;
			let data = this.sig.toData();
			if(data){
				data.pop();
				this.sig.fromData(data);
			}
		},
	},
	mounted(){
		this.$nextTick().then(() => {
			this.draw();
		});
	},
	destroyed(){
		window.removeEventListener("resize", this.resizeCanvas);
	}
});
